const STYLE = {
  standard: 'initial',
  fontSizeStandard: 16,
  fontSizeMedium: 22,
  fontSizeBig: 28,
  backgroundColor: '#9dd1ff',
  filter: 'grayscale(100%)',
  letterSpacingMedium: 5,
  letterSpacingBig: 7,
  lineHeightMedium: 1.5,
  lineHeightBig: 1.9,
}

const setStyle = (collection, property, value) => {
  const prop = property
  collection.forEach((item) => {
    if (typeof value === 'string') {
      item.style[prop] = value
    } else {
      item.style[prop] = `${value}px`
    }
  })
}

const setActiveButton = (buttons, activeValue) => {
  if (activeValue) {
    buttons.forEach((button) => {
      button.classList.remove('is-variant-outline')

      if (button.dataset.accessibilityAction !== activeValue) {
        button.classList.add('is-variant-outline')
      }
    })
  }
}

const fontSizeActions = (collection, action = 'standard') => {
  switch (action) {
    case 'medium':
      collection.forEach((item) => {
        setStyle(item, 'fontSize', STYLE.fontSizeMedium)
      })
      break
    case 'big':
      collection.forEach((item) => {
        setStyle(item, 'fontSize', STYLE.fontSizeBig)
      })
      break
    default:
      collection.forEach((item) => {
        setStyle(item, 'fontSize', STYLE.fontSizeStandard)
      })
  }
}

const bgColorActions = (collection, action = 'standard') => {
  switch (action) {
    case 'inversion':
      collection.forEach((item) => {
        setStyle(item, 'filter', STYLE.filter)
      })
      break
    case 'blue':
      collection.forEach((item) => {
        setStyle(item, 'backgroundColor', STYLE.backgroundColor)
      })
      break
    default:
      collection.forEach((item) => {
        setStyle(item, 'backgroundColor', '#fff')
        setStyle(item, 'filter', STYLE.standard)
      })
  }
}

const letterSpacingActions = (collection, action = 'standard') => {
  switch (action) {
    case 'medium':
      collection.forEach((item) => {
        setStyle(item, 'letterSpacing', STYLE.letterSpacingMedium)
      })
      break
    case 'big':
      collection.forEach((item) => {
        setStyle(item, 'letterSpacing', STYLE.letterSpacingBig)
      })
      break
    default:
      collection.forEach((item) => {
        setStyle(item, 'letterSpacing', STYLE.standard)
      })
  }
}

const lineHeightActions = (collection, action = 'standard') => {
  switch (action) {
    case 'medium':
      collection.forEach((item) => {
        setStyle(
          item,
          'lineHeight',
          STYLE.lineHeightMedium * STYLE.fontSizeMedium,
        )
      })
      break
    case 'big':
      collection.forEach((item) => {
        setStyle(item, 'lineHeight', STYLE.lineHeightBig * STYLE.fontSizeBig)
      })
      break
    default:
      collection.forEach((item) => {
        setStyle(item, 'lineHeight', `1.5rem`)
      })
  }
}

const setStorageValue = (key, value) => {
  localStorage.setItem(key, value)
}

const accessibilityActions = (property) => {
  const fontSizeButtons = document.querySelectorAll('[data-font-size-btn]')
  const colorButtons = document.querySelectorAll('[data-color]')
  const letterSpacingButtons = document.querySelectorAll(
    '[data-letter-spacing]',
  )
  const lineHeightButtons = document.querySelectorAll('[data-line-height]')

  const html = document.querySelectorAll('html')
  const sub = document.querySelectorAll('sub')
  const sup = document.querySelectorAll('sup')
  const button = document.querySelectorAll('button')
  const input = document.querySelectorAll('input')
  const optgroup = document.querySelectorAll('optgroup')
  const select = document.querySelectorAll('select')
  const textarea = document.querySelectorAll('textarea')
  const h1 = document.querySelectorAll('h1')
  const h2 = document.querySelectorAll('h2')
  const h3 = document.querySelectorAll('h3')
  const h4 = document.querySelectorAll('h4')
  const h5 = document.querySelectorAll('h5')
  const h6 = document.querySelectorAll('h6')
  const layoutWrapSectionsContentInnerP = document.querySelectorAll(
    '.layout-wrap-sections__content-inner p',
  )
  const layoutWrapSectionsContentInnerUlLi = document.querySelectorAll(
    '.layout-wrap-sections__content-inner ul li',
  )
  const layoutWrapSectionsContentInnerLi = document.querySelectorAll(
    '.layout-wrap-sections__content-inner li',
  )
  const modalHeaderTitle = document.querySelectorAll(
    '.modal-wrap .modal-header__title',
  )
  const modalInfoTextTitle = document.querySelectorAll(
    '.modal-wrap .modal-info__text-title',
  )
  const textBase = document.querySelectorAll('.text-base')
  const textH1 = document.querySelectorAll('.text-h1')
  const textH2 = document.querySelectorAll('.text-h2')
  const textH3 = document.querySelectorAll('.text-h3')
  const textH4 = document.querySelectorAll('.text-h4')
  const textH5 = document.querySelectorAll('.text-h5')
  const textH6 = document.querySelectorAll('.text-h6')
  const textLabel = document.querySelectorAll('.text-label')
  const classButton = document.querySelectorAll('.button')
  const sectionActions = document.querySelectorAll('.section__actions')
  const paginationPageNumbers = document.querySelectorAll(
    '.pagination .page-numbers',
  )
  const inputFieldCounter = document.querySelectorAll('.input-field .counter')
  const boxAboutPersonBlockquote = document.querySelectorAll(
    '.box-about-person__blockquote',
  )
  const statisticsSliderInfoSum = document.querySelectorAll(
    '.statistics-slider__info-sum',
  )
  const header = document.querySelectorAll('.header')
  const headerRow = document.querySelectorAll('.header__row')
  const headerRowIsItems = document.querySelectorAll('[data-header-sticky]')
  const layoutContent = document.querySelectorAll('.layout-content')
  const footer = document.querySelectorAll('.footer')

  switch (property) {
    case 'fontSizeStandard':
      fontSizeActions([html])
      setActiveButton(fontSizeButtons, 'fontSizeStandard')
      if (localStorage.getItem('font-size'))
        localStorage.removeItem('font-size')
      break
    case 'fontSizeMedium':
      fontSizeActions([html], 'medium')
      setActiveButton(fontSizeButtons, 'fontSizeMedium')
      setStorageValue('font-size', 'fontSizeMedium')
      break
    case 'fontSizeBig':
      fontSizeActions([html], 'big')
      setActiveButton(fontSizeButtons, 'fontSizeBig')
      setStorageValue('font-size', 'fontSizeBig')
      break
    case 'colorStandard':
      document.body.style.backgroundColor = STYLE.standard
      bgColorActions([
        html,
        header,
        headerRow,
        layoutContent,
        footer,
      ])
      setStyle(headerRowIsItems, 'backgroundColor', 'var(--color-primary)')
      setActiveButton(colorButtons, 'colorStandard')
      setStyle(footer, 'backgroundColor', '#eff5f9')
      if (localStorage.getItem('color')) localStorage.removeItem('color')
      break
    case 'colorInversion':
      document.body.style.backgroundColor = STYLE.standard
      bgColorActions([
        header,
        layoutContent,
        footer,
      ])
      bgColorActions([html, headerRowIsItems], 'inversion')
      setActiveButton(colorButtons, 'colorInversion')
      setStorageValue('color', 'colorInversion')
      break
    case 'colorBlue':
      document.body.style.backgroundColor = STYLE.standard
      bgColorActions([html, headerRowIsItems])
      bgColorActions(
        [
          header,
          headerRow,
          layoutContent,
          footer,
        ],
        'blue',
      )
      setActiveButton(colorButtons, 'colorBlue')
      setStorageValue('color', 'colorBlue')
      break
    case 'letterSpacingStandard':
      letterSpacingActions([html])
      setActiveButton(letterSpacingButtons, 'letterSpacingStandard')
      if (localStorage.getItem('letter-spacing'))
        localStorage.removeItem('letter-spacing')
      break
    case 'letterSpacingMedium':
      letterSpacingActions([html], 'medium')
      setActiveButton(letterSpacingButtons, 'letterSpacingMedium')
      setStorageValue('letter-spacing', 'letterSpacingMedium')
      break
    case 'letterSpacingBig':
      letterSpacingActions([html], 'big')
      setActiveButton(letterSpacingButtons, 'letterSpacingBig')
      setStorageValue('letter-spacing', 'letterSpacingBig')
      break
    case 'lineHeightStandard':
      lineHeightActions([
        html,
        sub,
        sup,
        button,
        input,
        optgroup,
        select,
        textarea,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        layoutWrapSectionsContentInnerP,
        layoutWrapSectionsContentInnerUlLi,
        layoutWrapSectionsContentInnerLi,
        modalHeaderTitle,
        modalInfoTextTitle,
        textBase,
        textH1,
        textH2,
        textH3,
        textH4,
        textH5,
        textH6,
        textLabel,
        classButton,
        sectionActions,
        paginationPageNumbers,
        inputFieldCounter,
        boxAboutPersonBlockquote,
        statisticsSliderInfoSum,
      ])
      setActiveButton(lineHeightButtons, 'lineHeightStandard')
      if (localStorage.getItem('line-height'))
        localStorage.removeItem('line-height')
      break
    case 'lineHeightMedium':
      lineHeightActions(
        [
          html,
          sub,
          sup,
          optgroup,
          select,
          textarea,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          layoutWrapSectionsContentInnerP,
          layoutWrapSectionsContentInnerUlLi,
          layoutWrapSectionsContentInnerLi,
          modalHeaderTitle,
          modalInfoTextTitle,
          textBase,
          textH1,
          textH2,
          textH3,
          textH4,
          textH5,
          textH6,
          textLabel,
          sectionActions,
          paginationPageNumbers,
          inputFieldCounter,
          boxAboutPersonBlockquote,
          statisticsSliderInfoSum,
        ],
        'medium',
      )
      setActiveButton(lineHeightButtons, 'lineHeightMedium')
      setStorageValue('line-height', 'lineHeightMedium')
      break
    case 'lineHeightBig':
      lineHeightActions(
        [
          html,
          sub,
          sup,
          optgroup,
          select,
          textarea,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          layoutWrapSectionsContentInnerP,
          layoutWrapSectionsContentInnerUlLi,
          layoutWrapSectionsContentInnerLi,
          modalHeaderTitle,
          modalInfoTextTitle,
          textBase,
          textH1,
          textH2,
          textH3,
          textH4,
          textH5,
          textH6,
          textLabel,
          sectionActions,
          paginationPageNumbers,
          inputFieldCounter,
          boxAboutPersonBlockquote,
          statisticsSliderInfoSum,
        ],
        'big',
      )
      setActiveButton(lineHeightButtons, 'lineHeightBig')
      setStorageValue('line-height', 'lineHeightBig')
      break
  }
}

const getStorageValue = (key) => {
  if ('localStorage' in window) {
    const storage = localStorage.getItem(key)

    if (storage) {
      accessibilityActions(storage)
    }
  }
}

const openAccessibilityModal = () => {
  const accessibilityButton = document.querySelector(
    '[data-button-accessibility]',
  )
  const accessibilityModal = document.querySelector(
    '[data-modal-accessibility]',
  )
  const accessibilityButtonMobile = document.querySelector(
    '[data-button-accessibility-mobile]',
  )
  const accessibilityCloseIcon = document.querySelector(
    '[data-accessibility-close-icon]',
  )

  const handleClickAccessibilityModal = () => {
    accessibilityModal && accessibilityModal.classList.remove('is-invisible')
    accessibilityModal && accessibilityModal.classList.add('is-layout-locked')

    document.addEventListener('click', (e) => {
      accessibilityActions(e.target.dataset.accessibilityAction)
    })
  }

  accessibilityButton &&
    accessibilityButton.addEventListener('click', handleClickAccessibilityModal)
  accessibilityButtonMobile &&
    accessibilityButtonMobile.addEventListener(
      'click',
      handleClickAccessibilityModal,
    )

  accessibilityCloseIcon &&
    accessibilityCloseIcon.addEventListener('click', () => {
      accessibilityModal && accessibilityModal.classList.add('is-invisible')
      accessibilityModal &&
        accessibilityModal.classList.remove('is-layout-locked')
    })

  getStorageValue('font-size')
  getStorageValue('color')
  getStorageValue('letter-spacing')
  getStorageValue('line-height')
}

document.addEventListener('DOMContentLoaded', openAccessibilityModal)
